import {isEmpty, isDate, isNumber, isPlainObject} from 'lodash/lang';
import moment from 'moment';
import validator from 'validator';

const isEmptyValue = (value) => {
  if (typeof value === 'string') {
    return isEmpty(value.trim());
  } else if (isPlainObject(value) && value.hasOwnProperty('value')) {
    return typeof value.value !== 'number' && isEmpty(value.value);
  }
  return isEmpty(value) && !isNumber(value) && !(value instanceof File);
};

export const isRequired = (value) => (isEmptyValue(value) && !isDate(value) ? 'This field is required' : undefined);

export const isEmail = (value) => (value && !validator.isEmail(value) ? 'Invalid email address' : undefined);

export const isEndDateAfterStartDate = (value, values) =>
  value && !moment(values.startDate).isBefore(values.endDate) ? 'End date must be after the start date' : undefined;

export const isSafePositiveInteger = (value) =>
  value && !validator.isInt(value.toString(), {min: 1, max: Number.MAX_SAFE_INTEGER})
    ? 'Invalid Positive Integer'
    : undefined;

export const isIntGTEZero = (value) =>
  value && !validator.isInt(value.toString(), {min: 0}) ? 'Invalid number' : undefined;

export const isYear = (value) =>
  value && !validator.isInt(value.toString(), {min: 1, max: new Date().getFullYear()}) ? 'Invalid year' : undefined;

export const isUsername = (value) =>
  value && !/^[a-zA-Z0-9_]+$/.test(value) ? 'Username can only contain a-z, A-Z, 0-9 or _' : undefined;

export const isPhoneNumber = (value) =>
  (value && !validator.isMobilePhone(value, 'any')) || (value && value.length < 8) ? 'Invalid Phone Number' : undefined;

export const isConfirmPasswordMatch = (value, values) =>
  value && values.password !== values.confirmPassword ? 'The passwords do not match, please try again.' : undefined;

export const isISBN = (value) => (value && !validator.isISBN(value) ? 'Invalid ISBN' : undefined);

export const isPage = (value) =>
  value && !validator.isInt(value.toString(), {min: 1, max: Number.MAX_SAFE_INTEGER}) ? 'Invalid Page' : undefined;

export const isPostCode = (value) => (value && !validator.isPostalCode(value, 'AU') ? 'Invalid Postcode' : undefined);
